import { Box, Container, Link } from "@mui/material";
import Grid from '@mui/material/Grid';
import React, { useState } from 'react';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MarkAsUnreadIcon from '@mui/icons-material/MarkAsUnread';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
function Footer() {

    const [text, setText] = useState('');
    return (
        <>
            <Box className="newsLetter">
                <Container maxWidth="md">
                    <Grid container spacing={2} justifyContent="center" alignItems="center">

                        <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                            <Box className="newsLetterBox">
                                <p>Sign up for our Newsletter</p>
                                <input type="text" placeholder="Email address" value={text} onChange={(e) => setText(e.target.value)} className="form-control" />
                            </Box>
                        </Grid>
                        <Grid size={{ xl: 1, lg: 1, md: 1, sm: 12, xs: 12 }} className="Mob-non"></Grid>
                        <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }}>
                            <Box className="newsLetterBox">
                                <p>Download Mobile App</p>
                                <img src="/assets/play-store.svg" className="img-fluid" />
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <footer className="footer">
                <img src="/assets/tample.png" className="footerTample" alt="Logo" />
                <Container maxWidth="md">



                    <Box className="mt-4">
                        <Grid container spacing={2} justifyContent="center">
                            <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }}>

                                <Box className="footerLogo">
                                    <img src="/assets/footer-logo.svg" alt="Logo" className="mb-3" />
                                    <p>Mandirwiki is an aggregator platform that consolidates reliable temple details, trip planning tools, flight booking, hotels, temple services, and more to provide an end-to-end pilgrimage solution. We have achieved a significant milestone by inaugurating the locker booking service at Shri Mata Vaishno Devi Shrine Board (SMVDSB). Developed by Arixpower India Pvt. Ltd.</p>
                                </Box>
                            </Grid>
                            <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }}>
                                <Box className="footerLinks ms-lg-4">
                                    <h3>Get in Touch</h3>
                                    <Box className="getInTouch">
                                        <p><LocalPhoneIcon />&nbsp;+91 9625974411 | +91 7292040480 </p>
                                        <p><MarkAsUnreadIcon />&nbsp;info@mandir.wiki | info@arixpower.com</p>
                                        <p><LocationOnIcon />&nbsp;203, 2-A/3, S/F Front Side, Asaf Ali Road, Turkman Gate, New Delhi-110002</p>
                                        <div className="ashokStambh">
                                            <ul>
                                                <li><Link href="../assets/startup-india-certificate.pdf" target="_blank"><img src="../assets/ashok-stambh.png" height="40" width="40" alt="" className="img-fluid" /></Link></li>
                                                <li><Link href="../assets/startup-india-certificate.pdf" target="_blank">Certificate Number: DIPP174000</Link></li>
                                            </ul>
                                        </div>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid size={{ xl: 2, lg: 2, md: 2, sm: 12, xs: 12 }}>
                                <Box className="footerLinks float-start">
                                    <h3>Company</h3>
                                    <ul>
                                        <li><a href="career">Careers</a></li>
                                        <li><a href="#">Advertise</a></li>
                                        <li><a href="privacy-policy">Privacy policy</a></li>
                                        <li><a href="terms-condition">Terms & Condition</a></li>
                                        <li><a href="refund-policy">Refund Policy</a></li>
                                    </ul>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>


                    <Box className="mt-2">
                        <Grid container spacing={2} justifyContent="center">
                            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                                <Box className="socialLinks">
                                    <h3>Let us connect</h3>
                                    <ul>
                                        <li><Link href="#"><FacebookIcon /></Link></li>
                                        <li><Link href="https://www.instagram.com/mandirwikiofficial"><InstagramIcon /></Link></li>
                                        <li><Link href="#"><LinkedInIcon /></Link></li>
                                        <li><Link href="#"><XIcon /></Link></li>
                                        <li><Link href="#"><YouTubeIcon /></Link></li>
                                    </ul>
                                </Box>
                            </Grid>

                        </Grid>
                    </Box>

                </Container>
                {/* <img src="/assets/plane-icon.svg" className="planeIcon" alt="Logo" /> */}

            </footer>
            <Box className="copyright">
                <Container maxWidth="md">
                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                            <p className="text-center">&copy; 2025 | Mandirwiki</p>
                        </Grid>
                        
                    </Grid>
                </Container>
            </Box>
        </>
    )
}

export default Footer;
